module.exports = __webpack_public_path__ + "static/media/19ю10.ff2f39cb.webp";